// 	export default  [
// { num:'1', code:'X0000001164', name: '尼可刹米注射液', type:'西药', jix:'注射剂', dum:'普通药', kinds:'神经系统用药', ATC:'', TATC:'否', OTC:'否', TEat:'否', date: '2024-11-26 21：30：22', Opter:'admin', zt: '可用', nz: '否' },
// 					{ num:'2', code:'X0000001165', name: '注射用重组人白介素_2（123ALA）', type:'西药', jix:'注射剂', dum:'普通药', kinds:'血液系统用药', ATC:'', TATC:'否', OTC:'否', TEat:'否', date: '2024-11-02 08：28：02', Opter:'杨勇', zt: '可用', nz: '否' },
// 					{ num:'3', code:'X0000001166', name: '复方泛影葡胺注射液', type:'西药', jix:'注射剂', dum:'普通药', kinds:'医学影像对比例', ATC:'', TATC:'否', OTC:'否', TEat:'否', date: '2024-11-16 21：20：12', Opter:'黄丹', zt: '可用', nz: '否' },
// 					{ num:'4', code:'X0000001167', name: '重组人生长激素注射液', type:'西药', jix:'注射剂', dum:'普通药', kinds:'内分泌系统用药', ATC:'', TATC:'否', OTC:'否', TEat:'否', date: '2024-11-20 21：10：24', Opter:'古永', zt: '可用', nz: '否' },
// // // ]

export default [
	{
		label: '全部',
		path:'',
		title:'全部',
		icon:'el-icon-news',
		children: [
			{
				label: '西药',
				path:'',
				title:'西药',
				icon:'el-icon-xichengyao',
				children: [
					{
					label: '神经系统用药',
					path:'',
					title:'神经系统用药',
					icon:'el-icon-shenjingneike',
						children: [
						{
							label: '麻醉药与麻醉辅助用药',
							path:'',
							title:'麻醉药与麻醉辅助用药',
							icon:'el-icon-mazui',
						}, {
							label: '精神药物',
							path:'',
							title:'精神药物',
							icon:'el-icon-shenjingneike',
						}]
					},
					{
						label: '儿科用药',
						path:'',
						title:'儿科用药',
						icon:'el-icon-xinshengerke',
					}]
			}, 
			{
				label: '中成药',
				path:'',
				title:'中成药',
				icon:'el-icon-qingrejiedu',
				children: [{
					label: '内科',
					path:'',
					title:'内科',
					icon:'el-icon-neike',
					children: [{
						label: '解表剂',
						path:'',
						title:'解表剂',
						icon:'el-icon-paint-tube-medium',
					}]
				}, {
					label: '外科',
					path:'',
					title:'外科',
					icon:'el-icon-putongwaike',
					children: [{
						label: '解毒消肿',
						path:'',
						title:'解毒消肿',
						icon:'el-icon-qingrejiedu',
					}]
				}]
			}, 
			{
				label: '民族药',
				path:'',
				title:'民族药',
				icon:'el-icon-chanpin-minzuyao',
			}, 
			{
				label: '血液',
				path:'',
				title:'血液',
				icon:'el-icon-blood',
			}, 
			{
				label: '疫苗',
				path:'',
				title:'疫苗',
				icon:'el-icon-yimiaoke',
			},
		]
	}
]

